import { useEffect, useState } from "react";
import Pocetna from "./Pocetna";
import Ugradi from "./Ugradi";
import Ucitaj from "./Ucitaj";

const MereModal = ({ handleConfirm, handleCancel, mere, allMere }) => {
  const [newMere, setNewMere] = useState(mere);
  const [currentState, setCurrentState] = useState("");

  useEffect(() => {
    setNewMere(mere);
  }, [mere]);

  return (
    <div
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "60%",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {currentState === "" && (
          <Pocetna
            handleConfirm={handleConfirm}
            handleCancel={handleCancel}
            newMere={newMere}
            setNewMere={setNewMere}
            setCurrentState={setCurrentState}
          />
        )}
        {currentState === "UGRADI" && (
          <Ugradi setNewMere={setNewMere} setCurrentState={setCurrentState} />
        )}
        {currentState === "UCITAJ" && (
          <Ucitaj
            setNewMere={setNewMere}
            setCurrentState={setCurrentState}
            initialMere={newMere}
            allMere={allMere}
          />
        )}
      </div>
    </div>
  );
};

export default MereModal;
